import ITranslation from '@/global/localisation/translation'

export default abstract class Translation implements ITranslation {
    public abstract infos: {
        code: string
        name: string
    }
    public abstract data: {
        layout: {
            languagePicker: {
                chooseLanguage: string
            }
            navbar: {
                title: string
                hello: string
                darkTheme: string
                lightTheme: string
                profile: string
                logout: string
            }
            footer: {
                copyright: string
            }
            menu: {
                home: string
                profile: string
                users: string
                facturations: string
                suiviCA: string
                suiviConso: string
                formulaires: string
                contact: string
                etatStock: string
                pmnAdministration: string
                PMN: string
                GED: string
                Evenements: string
                formulairesReponseAdministration: string
                inventaires: string
                commandes: string
                ficheImplantation: string
                ficheImplantationAdmin: string
                importRotationProduits: string
                suiviRecueil: string
                kits : string
                actualites : string
            }
        }
        auth: {
            login: {
                title: string
                helper: string
                email: string
                password: string
                forgottenPassword: string
                register: string
                noAccount: string
                submit: string
            }
            register: {
                title: string
                helper: string
                login: string
                alreadyRegistered: string
                firstname: string
                lastname: string
                email: string
                password: string
                confirmPassword: string
                phoneNumber: string
                passwordNoMatch: string
                submit: string
            }
        }
        profile: {
            infos: string
            welcome: string
            edit: string
            email: string
            lastname: string
            firstname: string
            phoneNumber: string
            validate: string
        }
        plugins: {
            validation: {
                required: string
                min: string
                max: string
                email: string
            }
            swall: {
                alert: {
                    error: string
                    success: string
                    warning: string
                }
                confirm: {
                    titreSuppression: string
                    texteSuppression: string
                    confirmSuppression: string
                    cancelSuppression: string
                    cancel: string
                }
                toast: {
                    success: string
                    error: string
                }
                ok: string
                erreurServeur: string
                codeErreur: string
                erreurConnexion: string
            }
        }
    }
}
